/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Progress, Button } from '@elevio/elevio-styles/dist/components/hq';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import CustomForm from '../../components/customForm';
import Notif from '../../components/notif';
import LoadingError from '../../components/loadingError';
import Loader from '../../components/loader';
import styles from './style.css';

@withRouter
@inject('settingsStore')
@inject('formStore')
@observer
export default class Home extends React.Component {
  static propTypes = {
    formStore: PropTypes.shape({
      save: PropTypes.func,
      isLoading: PropTypes.bool,
      isSaving: PropTypes.bool,
      onChange: PropTypes.func,
      form: PropTypes.shape({
        title: PropTypes.string,
      }),
      hasGateKeeperEnabled: PropTypes.bool,
      hasError: PropTypes.bool,
      saveError: PropTypes.bool,
      buttonText: PropTypes.string,
      isSaved: PropTypes.bool,
      saveClicked: PropTypes.bool,
      completion: PropTypes.number.isRequired,
      notifications: PropTypes.oneOfType([
        mobxPropTypes.observableArray,
        PropTypes.array,
      ]),
      selectedOptions: mobxPropTypes.observableMap,
    }).isRequired,
    settingsStore: PropTypes.shape({
      locales: PropTypes.shape({
        general: PropTypes.shape({
          error: PropTypes.string,
          something_went_wrong: PropTypes.string,
        }),
        modules: PropTypes.shape({
          support: PropTypes.shape({
            add_files: PropTypes.string,
          }),
        }),
      }),
      isLoading: PropTypes.bool,
    }).isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidUpdate() {
    const { history, formStore } = this.props;
    const { isSaved, isValid } = formStore;

    if (isSaved && isValid) {
      history.push('/gatekeeper');
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    const { formStore, history } = this.props;
    const { submitPressed, save, hasGateKeeperEnabled, isValid } = formStore;

    submitPressed();

    if (hasGateKeeperEnabled && isValid) {
      history.push('/gatekeeper');
      return;
    }

    save();
  };

  render() {
    const {
      hasError,
      isLoading,
      notifications,
      form: { title },
      completion,
      isSaving,
      buttonText,
    } = this.props.formStore;

    const {
      locales: {
        general: { something_went_wrong, error }, // eslint-disable-line camelcase
      },
      isLoading: settingsLoading,
    } = this.props.settingsStore;

    if (hasError) {
      return (
        <LoadingError
          store={this.props.formStore}
          errorMsg={something_went_wrong} // eslint-disable-line camelcase
          suggestionMsg={error}
        />
      );
    }

    if (isLoading || isSaving || settingsLoading) {
      return <Loader />;
    }

    return (
      <div className={styles.customForm}>
        <Progress showInfo={false} percent={completion} />
        <h3 className={styles.header}>{title}</h3>
        {notifications.length > 0 && (
          <div className={styles.notificationContainer}>
            {notifications.map(notif => (
              <Notif key={notif.text} text={notif.text} type={notif.type} />
            ))}
          </div>
        )}
        <CustomForm {...this.props} />
        <div className={styles.buttonContainer}>
          <Button
            htmlType="submit"
            className={cx({
              [styles.disabled]: isSaving,
              [styles.resetButton]: true,
              [styles.button]: true,
            })}
            disabled={isSaving}
            onClick={this.handleSubmit}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js